<template>
    <img src="@/assets/images/paperback-logo.svg" alt="Paperback logo" />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'PaperbackLogo',
})
</script>
